export const EmployeeStatus = {
    salaried: 'salarie',
    internship: 'stagiaire',
    retired: 'retraite',
};
export const Gender = {
    man: 'man',
    woman: 'woman',
    other: 'other',
};
export const EmailPreference = {
    professional: 'pro',
    personal: 'perso',
};
export const BeneficiaryValidationStatus = {
    awaitingValidation: 'awaitingValidation',
    validated: 'validated',
    refused: 'refused',
};
export const EmployeeBeneficiaryStatus = {
    married: 'married',
    child: 'child',
};
export const EmployeeBeneficiaryValidationStatus = {
    awaitingValidation: 'awaitingValidation',
    validated: 'validated',
    refused: 'refused',
};
export const DocumentStatus = {
    awaitingValidation: 'awaitingValidation',
    validated: 'validated',
    refused: 'refused',
};
export const ActionLogType = {
    creation: 'creation',
    modification: 'modification',
    deletion: 'deletion',
};
export const EmployeeDocumentType = {
    identityCard: 'identityCard',
    payslip: 'payslip',
    rib: 'rib',
};
export const EmployeeBeneficiaryDocumentType = {
    familyRecord: 'familyRecord',
    schoolCertificate: 'schoolCertificate',
};
export const PrestationMode = {
    registration: 'registration',
};
